module.exports = __webpack_public_path__ + "static/media/truck.0942dc4b.svg";